<template>
  <svg width="22" height="40" viewBox="0 0 22 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.943 16.232c.064.26.075.56.03.835-.046.275-.142.503-.27.633l-6.46 6.56a.341.341 0 0 1-.241.115.341.341 0 0 1-.241-.116L4.3 17.7a.836.836 0 0 1-.168-.26 1.613 1.613 0 0 1-.105-.372 2.164 2.164 0 0 1 .03-.838 1.33 1.33 0 0 1 .129-.339.615.615 0 0 1 .184-.21.29.29 0 0 1 .21-.052c.07.011.139.051.202.117l6.219 6.312 6.219-6.312c.127-.13.275-.152.41-.06.136.091.248.288.312.547z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ color?: string }>(), { color: '#5b6c50' });
</script>
